module.exports = __webpack_public_path__ + "static/kelly-Fun-e1b5b2482107a9055ed08bc94844604f.jpg";